import { ThemeOptions } from '@mui/material';
import type {} from '@mui/x-charts/themeAugmentation';

import { capitalCategoricalPalette } from '../../capitalCategoricalPalette';

export const MuiScatterChart: ThemeOptions['components']['MuiScatterChart'] = {
  defaultProps: {
    colors: capitalCategoricalPalette,
    enableKeyboardNavigation: true
  }
};
